var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"temp-loader-container",attrs:{"id":"temp-loading-bg"}},[_c('div',{staticClass:"temp-svg-container"},[_c('DecastAnimatedLogo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }